import { useNavigate, useParams } from 'react-router-dom';
import { LeadDrawer } from '../components/leads/LeadDrawer';

/** /leads/:id — a mesma ficha do drawer, em tela cheia (link compartilhável). */
export function LeadDetailPage() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  return <LeadDrawer leadId={id} asPage onClose={() => navigate('/leads')} />;
}
